module.exports = __webpack_public_path__ + "assets/img/首页-蘑菇小兵.50b5f611.jpg";